import type { Auth } from "firebase/auth";

export function getCurrentUserString(auth: Auth): string | null {
  const u = auth.currentUser;
  if (!u) return null;
  return u.email || u.uid || null;
}
